import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Spinner, Alert, Pagination, Modal } from 'react-bootstrap';
import Carousel from 'react-bootstrap/Carousel';
import defaultImage from "../assets/default.png";
import { API_URL, UPLOADS_API_URL } from "../config";

const ProductDisplay = ({ loading, setLoading }) => {
    const [items, setItems] = useState([]);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPageState] = useState(1);
    const itemsPerPage = 12; 
    const [currentItems, setCurrentItems] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);
    const [selectedImage, setSelectedImage] = useState('');
    const [selectedItem, setSelectedItem] = useState({}); // Store selected item information

    const companyId = localStorage.getItem("company_id");
    const branchId = localStorage.getItem("branch_id");

    useEffect(() => {
        const fetchProducts = async () => {
            setLoading(true);
            setError(null); // Reset error state before fetching

            console.log("mycompanyId",companyId);
            console.log("mybranchId",branchId);
            try {
                const response = await fetch(`${API_URL}/productdefinition/full_products_definitions_by_company_id_branch_id/${companyId}/${branchId}`);
                if (!response.ok) {
                    throw new Error('Failed to fetch products');
                }
                const data = await response.json();

                // Filter products based on company_id and branch_id
                const filteredItems = data;

                setItems(filteredItems);
                const total = Math.ceil(filteredItems.length / itemsPerPage);
                setTotalPages(total);
                setCurrentItems(filteredItems.slice(0, itemsPerPage));
            } catch (err) {
                console.error("Error fetching products:", err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, [companyId, branchId, setLoading]);

    useEffect(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;

        if (!Array.isArray(items)) {
            console.error("Items is not an array:", items);
            return;
        }

        if (startIndex < 0 || endIndex > items.length || startIndex >= items.length) {
            console.error("Invalid indices for current items:", { startIndex, endIndex, itemsLength: items.length });
            return;
        }

        setCurrentItems(items.slice(startIndex, endIndex));
    }, [currentPage, items]);

    const handleCardClick = (item) => {
        const images = [
            item.uploaded_product_image_ref,
            item.uploaded_product_image_ref2,
            item.uploaded_product_image_ref3,
            item.uploaded_product_image_ref4,
            item.uploaded_product_image_ref5,
            item.uploaded_product_image_ref6,
            item.uploaded_product_image_ref7,
        ].filter(Boolean); // Remove null values

        setSelectedImages(images);
        setSelectedImage(images[0] || defaultImage); // Set first image as selected or default
        setSelectedItem(item); // Set the selected item information
        setShowModal(true);
    };

    return (
        <>
            {error && (
                <Alert variant="danger" dismissible>
                    {error}
                </Alert>
            )}
            {loading ? (
                <div className="text-center py-5">
                    <Spinner animation="border" variant="primary" />
                </div>
            ) : (
                <>
                    {items.length === 0 ? (
                        <Alert variant="info" className="text-center">
                            No products yet.
                        </Alert>
                    ) : (
                        <Row>
                            {currentItems.map((item) => {
                                const mainImage = [
                                    item.uploaded_product_image_ref,
                                    item.uploaded_product_image_ref2,
                                    item.uploaded_product_image_ref3,
                                    item.uploaded_product_image_ref4,
                                    item.uploaded_product_image_ref5,
                                    item.uploaded_product_image_ref6,
                                    item.uploaded_product_image_ref7,
                                ].find(img => img) || defaultImage;

                                return (
                                    <Col key={item.product_id} md={3} className="mb-4">
                                        <Card className="h-100 shadow-sm border-warning" onClick={() => handleCardClick(item)}>
                                            <div className="position-relative" style={{ height: "150px" }}>
                                                <img
                                                    className="d-block w-100 h-100"
                                                    src={`${UPLOADS_API_URL}/${mainImage}`}
                                                    alt={item.product_name}
                                                    style={{ objectFit: "contain" }}
                                                />
                                            </div>
                                            <Card.Body>
                                                <Card.Title className="h5 mb-2">{item.product_name}</Card.Title>
                                                <Card.Text className="text-muted small mb-2">{item.product_brand}</Card.Text>
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <span className="text-success fw-bold">${item.selling_price}</span>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                );
                            })}
                            {currentItems.length < 4 && (
                                [...Array(4 - currentItems.length)].map((_, idx) => (
                                    <Col key={`empty-${idx}`} md={3} className="mb-4" style={{ visibility: 'hidden' }}>
                                        <Card className="h-100 shadow-sm border-warning">
                                            <div className="position-relative" style={{ height: "150px" }}>
                                                <Card.Img
                                                    variant="top"
                                                    src={defaultImage}
                                                    style={{ height: "100%", width: "100%", objectFit: "cover" }}
                                                />
                                            </div>
                                        </Card>
                                    </Col>
                                ))
                            )}
                        </Row>
                    )}
                </>
            )}
            {items.length > 0 && (
                <div className="d-flex justify-content-center mt-4">
                    <Pagination>
                        <Pagination.First onClick={() => setCurrentPageState(1)} />
                        <Pagination.Prev onClick={() => setCurrentPageState((prev) => Math.max(prev - 1, 1))} />
                        {[...Array(totalPages)].map((_, idx) => (
                            <Pagination.Item
                                key={idx + 1}
                                active={idx + 1 === currentPage}
                                onClick={() => setCurrentPageState(idx + 1)}
                            >
                                {idx + 1}
                            </Pagination.Item>
                        ))}
                        <Pagination.Next onClick={() => setCurrentPageState((prev) => Math.min(prev + 1, totalPages))} />
                        <Pagination.Last onClick={() => setCurrentPageState(totalPages)} />
                    </Pagination>
                </div>
            )}

            <Modal show={showModal} onHide={() => setShowModal(false)} size="md">
                <Modal.Header closeButton>
                    <Modal.Title>{selectedItem.product_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Only show the selected main image, not in the carousel */}
                    <img
                        src={selectedImage ? `${UPLOADS_API_URL}/${selectedImage}` : defaultImage}
                        alt="Selected"
                        style={{ width: "50%", height: "auto", marginBottom: "1rem" }}
                    />
                    <Carousel controls>
                        {selectedImages.map((img, index) => (
                            <Carousel.Item key={index}>
                                <img
                                    className="d-block w-100"
                                    src={`${UPLOADS_API_URL}/${img}`}
                                    alt={`Slide ${index}`}
                                    style={{ height: "100px", objectFit: "cover" }} // Adjust height as needed
                                />
                                <Carousel.Caption>
                                    <h5>{selectedItem.product_name}</h5>
                                    <p>{selectedItem.product_brand}</p>
                                    <p>{selectedItem.product_description || 'Description not available.'}</p>
                                </Carousel.Caption>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ProductDisplay;